import axios from 'axios'

import Termly from 'termly-namespace'

import URL from 'utils/url'


export default function statisticViewApiCall({ eventTypes, impressionLimit }) {
  const postURL = URL.statistic()

  const args = {
    event_types: eventTypes,
    website_uuid: Termly.websiteUUID,
  }

  // eslint-disable-next-line eqeqeq
  if ( impressionLimit != void 0 ) {
    args.impression_limit = impressionLimit
  }

  return axios
    .post(postURL, args)
    .catch(({ message }) => {
      console.error('Encountered %o when trying to post statistics to %s',
                    message,
                    postURL)
    })
}
